module.exports = __webpack_public_path__ + "img/undraw_heart.d2a31f9e.svg";